import { apiFetch } from "./client";

export type EmailPreview = {
  template: string;
  locale: string;
  html: string;
  text: string;
};

export type EmailTemplatesIndex = {
  templates: string[];
  locales: string[];
  samples: Record<string, Record<string, unknown>>;
};

export const emailsApi = {
  templates: () => apiFetch<EmailTemplatesIndex>("/admin/emails/templates"),
  preview: (template: string, locale: string, model: Record<string, unknown> | null) =>
    apiFetch<EmailPreview>("/admin/emails/preview", {
      method: "POST",
      body: { template, locale, model },
    }),
};
